<template>
  <modal
    :name="modalName"
    width="90%"
    height="auto"
    :max-width="900"
    :adaptive="true"
    :scrollable="true"
    @opened="focusClose"
    @before-close="beforeClose"
  >
    <div
      class="automation-variable-value-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="automation-variable-value-title"
      @keyup.esc.stop.prevent="$emit('close')"
    >
      <AppModalHeader
        ref="header"
        design="new"
        :title="label"
        :eyebrow="`Template variable · Delivery #${deliveryId}`"
        title-id="automation-variable-value-title"
        @close="$emit('close')"
      />
      <main class="automation-variable-value-body">
        <pre tabindex="0">{{ value }}</pre>
      </main>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'FollowUpAutomationVariableValueModal',
  props: {
    deliveryId: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    modalName() {
      return `automation-variable-value-${this.deliveryId}`
    }
  },
  mounted() {
    this.$modal.show(this.modalName)
  },
  methods: {
    focusClose() {
      this.$refs.header.focusClose()
    },
    beforeClose(event) {
      event.cancel()
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.automation-variable-value-dialog {
  overflow: hidden;
  border-radius: $ui-overlay-radius;
  background: $ui-surface-soft;
  color: $ui-text;
  font: #{$ui-font-size-body}/ 1.45 $ui-font-body;
}

.automation-variable-value-body {
  padding: $ui-space-20;
}

.automation-variable-value-body pre {
  min-height: 180px;
  margin: 0;
  padding: $ui-space-16;
  border: 1px solid $ui-line;
  border-radius: $ui-panel-radius;
  background: $ui-surface;
  color: $ui-text;
  font-family: monospace;
  font-size: $ui-font-size-body;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

@media (max-width: 600px) {
  .automation-variable-value-body {
    padding: $ui-space-12;
  }
}
</style>
